 <template >
  <div>
     <div class="vx-row formSearch1" v-scrollanimation>
        <vs-col
        vs-offset="2"
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-w="8"
        v-if= "this.$store.state.windowWidth>1200"
      >
        <vx-card>
          <b-row>
            <b-col cols="6">
              <vs-input
                class="w-full"
                icon-pack="feather"
                icon="icon-map-pin"
                label-placeholder="Entrer le lieu"
                v-model="place"
            /></b-col> 
             <b-col style="marginTop: 18px" cols="3"
              ><b-form-select
                v-model="selected"
                :options="locationType"
                size="lg"
              ></b-form-select
            ></b-col>
            <b-col>
              <vs-button style="marginTop: 18px" @click="search"
                >Rechercher</vs-button
              ></b-col
            >
             <b-col>
              <vs-button style="marginTop: 18px" @click="filtre_popup_appear()"
                >Filtres</vs-button
              ></b-col
            >
            <b-col>
              <vs-button style="marginTop: 18px" @click="clear()"
                >Effacer les filtres</vs-button
              ></b-col
            >
          </b-row>
        </vx-card>
      </vs-col>
      <vs-col
        vs-offset="1"
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-w="10"
        v-else
      >
        <vx-card>
          <b-row>
            <b-col cols="12">
              <vs-input
                class="w-full"
                icon-pack="feather"
                icon="icon-map-pin"
                label-placeholder="Entrer le lieu"
                v-model="place"
            /></b-col> 
             <b-col style="marginTop: 18px" cols="12"
              ><b-form-select
                v-model="selected"
                :options="locationType"
                size="lg"
              ></b-form-select
            ></b-col>
            <b-col>
              <vs-button style="marginTop: 18px" @click="search"
                >Rechercher</vs-button
              ></b-col
            >
             <b-col>
              <vs-button style="marginTop: 18px" @click="filtre_popup_appear()"
                >Filtres</vs-button
              ></b-col
            >
            <b-col>
              <vs-button style="marginTop: 18px" @click="clear()"
                >Effacer les filtres</vs-button
              ></b-col
            >
          </b-row>
        </vx-card>
      </vs-col>
    </div>
    <br>
    <h1>Logements en location  <strong>{{this.$route.query.place}}</strong></h1>
    <!-- <div class="vx-row">
      <div>
        <vs-row>
          <vs-col
            :key="index"
            v-for="(col, index) in 2"
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="6"
          >
            50%
          </vs-col>
        </vs-row>
      </div>
    </div> -->
    <div class="vx-row"  v-if="loading==true">

      <div v-for="item in 10" :key="item.objectID" class="vx-col homeCard">
        <template loading>
        <b-card>
          <b-skeleton-img></b-skeleton-img>
          <br>
          <b-skeleton  animation="throb"  width="55%"></b-skeleton>
          <br>
          <b-skeleton  animation="throb" width="70%"></b-skeleton>
        </b-card>
        <br>
      </template>
      </div>
    </div>

    <div class="vx-row" v-scrollanimation v-appear:left="{ delay: 100 * 2}">
      <div v-for="item in homeInRenting" :key="item.objectID">
        <div class="home">
            <div class="vx-col homeCard">
              <vx-card >
                <div></div>
                <div slot="no-body" @click="navigate_to_detail_view(item._id)">
                  <img
                    :src= "imageOfHome(item)"
                    alt="content-img"
                    class="responsive card-img-top"
                  />
                </div>
                <h5 class="mb-2" @click="navigate_to_detail_view(item._id)">{{ item.home.name }}</h5>
                <p class="text-grey" @click="navigate_to_detail_view(item._id)">{{ item.home.adress }}</p>
                 <!-- <feather-icon
                        icon="HeartIcon"
                        svgClasses="h-8 w-8 text-primary stroke-current"
                        class="heart"
                      /> -->
                               <!-- <div
                                                class="item-view-primary-action-btn p-3 rounded-lg flex flex-grow items-center justify-center cursor-pointer mb-3"
                                                @click="toggleItemInWishList(item)">
                                                <feather-icon icon="HeartIcon" :svgClasses="[{'text-danger fill-current' : isInWishList(item.objectID)}, 'h-4 w-4']" />
                                                <span class="text-sm font-semibold ml-2">WISHLIST</span>
                                            </div> -->
                        <p class="h1 mb-2" v-if="!isInWishList(item._id)">  <b-icon icon="heart" aria-hidden="true" variant="danger" @click="toggleItemInWishList(item)"></b-icon> </p>
                        <p class="h1 mb-2" v-if="isInWishList(item._id)">  <b-icon icon="heart-fill" aria-hidden="true" variant="danger" @click="toggleItemInWishList(item)"></b-icon> </p>
              
              </vx-card>
          </div>
          <!-- <b-card
            img-src="https://images.unsplash.com/photo-1528047705243-ebb19baf436f?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=675&q=80"
            img-alt="Image"
            img-height="250px"
            img-top
            tag="article"
            style="max-width: 20rem; min-height: 29rem; max-height: 29rem"
            class="mb-2"
            @click="navigate_to_detail_view"
          >
            <b-card-title>{{ item.home.name }}</b-card-title>
            <b-card-text>
              {{ item.description }}
            </b-card-text>
            <b-card-text>
              {{ item.price }}
            </b-card-text>
            <template #footer>
              <small class="text-muted">Footer Text</small>
            </template>
          </b-card> -->
        </div>
      </div>
    </div>

      <div v-if="homeInRenting.length==0 && loading ==false" style="margin : 50px">
       <h1> Aucun résultat </h1> 
       <p>Pour obtenir plus de résultats, essayez de modifier votre recherche</p>
    </div>

     <vs-popup class="danger" title="Filtres" :active.sync="filter_popup">
       

      <b-form-group id="input-group-2" label="Chambres" label-for="input-2">
        <b-form-input
          id="input-2"
          v-model="bedroom"
          type="number"
          placeholder=""
          required
        ></b-form-input>
      </b-form-group>
      
      <b-form-group id="input-group-2" label="Lits" label-for="input-2">
        <b-form-input
          id="input-2"
          v-model="bed"
           type="number"
          placeholder="bed"
          required
        ></b-form-input>
      </b-form-group>
      <b-form-group id="input-group-2" label="Salle de bains" label-for="input-2">
        <b-form-input
          id="input-2"
          v-model="bathroom"
          placeholder="bathroom"
           type="number"
          required
        ></b-form-input>
      </b-form-group>
      <b-form-group id="input-group-2" label="Prix minimum" label-for="input-2">
        <b-form-input
          id="input-2"
          v-model="min_price"
          placeholder=""
           type="number"
          required
        ></b-form-input>
      </b-form-group>
      <b-form-group id="input-group-2" label="Prix maximum" label-for="input-2">
        <b-form-input
          id="input-2"
          v-model="max_price"
          placeholder=""
           type="number"
          required
        ></b-form-input>
      </b-form-group>
      <b-form-group id="input-group-2" label="Date d'entre" label-for="input-2">
        <b-form-input
          id="input-2"
          v-model="dateBegin"
          placeholder=""
          required
          type="date"
        ></b-form-input>
      </b-form-group>
      <b-form-group id="input-group-2" label="Date de sortie" label-for="input-2">
        <b-form-input
          id="input-2"
          v-model="dateEnd"
          type="date"
          placeholder=""
          required
        ></b-form-input>
      </b-form-group>
  
      <b-button type="submit" variant="primary" @click="search_with_filter()">Submit</b-button>
      <b-button type="reset" variant="danger">Reset</b-button>
     </vs-popup>
  
  </div>
</template>
                        
<script>
import axios from '@/helpers/axios'
export default {
  components: {
  },
  data () {
    return {
      loading : false,
      filter_popup :false,
      homeInRenting: [],
      place :this.$route.query.place,
      selected : this.$route.query.category,
      bed : 0,
      bedroom :0,
      bathroom : 0,
      dateBegin : '',
      dateEnd :'',
      min_price : 0,
      max_price :0,
      locationType: [
        { value: null, text: 'Choisis une option' },
        {
          value: 'Logement entier',
          text: 'Logement entier'
        },
        {
          value: 'Chambre partagée',
          text: 'Chambre partagée'
        },
        {
          value: 'Chambre privée',
          text: 'Chambre privée'
        }
      ]
    }
  },
  methods: {

    imageOfHome (item) {
      if (item.home.pic.length > 0) {
        return `data:image/jpg;base64,${ item.home.pic[0].img.data}`
      }
      return 'https://i.pinimg.com/originals/2b/36/2f/2b362f7ea3e8b33f64260f01dd739a48.png'
    },
    // GRID VIEW - ACTIONS
    toggleItemInWishList (item) {
      this.$store.dispatch('eCommerce/toggleRentalHouseInWishList', item)
    },
    addItemInCart (item) {
      this.$store.dispatch('eCommerce/addItemInCart', item)
    },
    cartButtonClicked (item) {
      this.isInCart(item.objectID) ? this.$router.push('/apps/eCommerce/checkout').catch(() => {}) : this.addItemInCart(item)
    },
    clear () {
      this.bed = 0
      this.bedroom = 0
      // eslint-disable-next-line no-unused-expressions
      this.bathroom = 0,
      this.dateBegin = '',
      this.dateEnd = '',
      this.min_price = 0,
      this.max_price = 0
    },
    filtre_popup_appear () {
      this.filter_popup = true
    },
  
    navigate_to_detail_view (itemId) {
      this.$router
        .push({
          name: 'houseRentItemdetails',
          params: { item_id: itemId }
        })
        .catch(() => {})
    },
    startLoading () {
      this.loading = true
    },
    search () {
      if (this.selected !== null) {
        this.$router
          .push({
            name: 'rental',
            query: { place: this.place,
              category: this.selected}
          }).catch(() => {})
      } else {
        this.$router
          .push({
            name: 'rental',
            query: { place: this.place}
          })
      }
      
      
    },
    search_with_filter () {
      this.filter_popup = false
      if (this.selected !== undefined) {
        this.$router
          .push({
            name: 'rental',
            query: { place: this.place,
              category: this.selected,
              bed :this.bed,
              bedroom :this.bedroom,
              bathroom:this.bathroom,
              dateBegin:this.dateBegin,
              dateEnd:this.dateEnd,
              min_price :this.min_price,
              max_price:this.min_price}
          }).catch(() => {})
      } else {
        this.$router
          .push({
            name: 'rental',
            query: { place: this.place,
              bed :this.bed,
              bedroom :this.bedroom,
              bathroom:this.bathroom,
              dateBegin:this.dateBegin,
              dateEnd:this.dateEnd,
              min_price :this.min_price,
              max_price:this.min_price}
          })
      }
    },
    fetch_home () {
      if (this.$route.query.place) {
        if (this.selected === null) {
          this.selected = undefined
        }
        axios.get(`/home/rental/find/withMultipleQuery?place=${this.$route.query.place}&categoryLocation=${this.selected}&dateBegin=${this.dateBegin}&dateEnd=${this.dateEnd}&bedroom=${this.bedroom}&bed=${this.bed}&bathroom=${this.bathroom}&min_price=${this.min_price}&max_price=${this.$max_price}`).then((response) => {
          this.homeInRenting = response.data
          this.loading = false
         
        })        
      } else {
        axios.get('/home/rental/published').then((response) => {
          this.homeInRenting = response.data
          this.loading = false
        })
      } 
    }
  },
  watch: {
    homeInRenting (val) {
      this.homeInRenting = val
    },
    '$route' () {
      this.fetch_home()
    }
    
  },
  computed: {
    isInCart () {
      return (itemId) => this.$store.getters['eCommerce/isInCart'](itemId)
    },
    isInWishList () {
      return (itemId) => this.$store.getters['eCommerce/isInRentalHouseWishList'](itemId)
    }
  },
  mounted () {
    this.startLoading()
    this.fetch_home()
  
  }
}
</script>
<style lang="scss">

.home {
  margin: 10px;
}


.homeCard{
  min-width: 300px;
  max-width: 300px;


  img{
  height: 250px;
}
}
.homeCard:hover{
  translate: translateZ(10px);
  cursor: pointer;
}


@media (min-width: 992px) {
  .vs-sidebar-rounded {
    .vs-sidebar {
      border-radius: 0.5rem;
    }

    .vs-sidebar--items {
      border-radius: 0.5rem;
    }
  }
}

@media (max-width: 992px) {
  #algolia-content-container {
    .vs-sidebar {
      position: absolute !important;
      float: none !important;
    }
  }
}
</style>
